export function getMaskedMoveAnimation(element, settings, animationcalculation){
    const animation = {
        y: 0,
        x: 0
    };

    //Set the position properties based on the startposition
    if( settings.start_position ){
        const ownFontSize = element.data('fontsize') ?? 1
        // set y position
        if( settings.start_position.indexOf("top") > -1 ){
            animation.y =  `-=${(element.outerHeight() / animationcalculation.scale * animationcalculation.pxemratio) / ownFontSize}em`;
        }else if( settings.start_position.indexOf("bottom") > -1 ){
            animation.y = `+=${(element.outerHeight() / animationcalculation.scale * animationcalculation.pxemratio) / ownFontSize}em`;
        }
        // set x position
        if( settings.start_position.indexOf("left") > -1 ){
            animation.x = `-=${(element.outerWidth() / animationcalculation.scale * animationcalculation.pxemratio) / ownFontSize}em`;
        }else if( settings.start_position.indexOf("right") > -1 ){
            animation.x = `+=${(element.outerWidth() / animationcalculation.scale * animationcalculation.pxemratio) / ownFontSize}em`;
        }
    }
    return animation;
}

const directionToTransformOriginMap = {
    topleft: "100% 100%",
    top: "50% 100%",
    topright: "0% 100%",
    left: "100% 50%",
    center: "50% 50%",
    right: "0% 50%",
    bottomleft: "100% 0%",
    bottom: "50% 0%",
    bottomright: "0% 0%",
}
export function getMaskedZoomAnimation(element, settings){
    return {
        transformOrigin: directionToTransformOriginMap[settings.start_position ?? 'center'],
        scale: settings.zoom / 100,
    }
}
